import api from "@/http/apis"
import {
	ElMessage
} from "element-plus"
import { sessionStorage } from "@/utils/sessionStorage"
export default ({
	namespaced: "true",
	state: {
		userInfo: "",
		userMenu: [],
	},
	getters: {},
	mutations: {
		setUserInfo(state, val) {
			console.info('setUserInfo',val)
		
			state.userInfo = val
			sessionStorage.set('user', state)
		
		},
		setUserMenu(state,val) {
			console.info('setUserMenu',val)
		
			state.userMenu = val
			sessionStorage.set('user', state)
		
		},		
	},
	actions: {
		async setUserMenu(context) {
			const {
				data
			} = await api.menuApi.getUserMenuTree()
			if (data.isSuccessful) {
				if (data.resultObj.length) {
					context.commit('setUserMenu', data.resultObj)
				  } else {
					context.commit('setUserMenu',[])
					ElMessage({
					  message: "当前账号没有设置可用的菜单，请联系管理员",
					  type: "error",
					})
				}
			} else {
				context.commit('setUserMenu',[])
				if (data.resultMsg) {
					ElMessage({
						message: data.resultMsg,
						type: "error",
					})
				} else {
					ElMessage({
						message: '未知错误，请联系管理员',
						type: "error",
					})
				}
			}
		}
	},

})
